// A short quiet period is not proof that a virtualized conversation has loaded.
// Only release its opening pin once the current tail exists and is measured.
export function isChatHistoryPositionReady(element, { targetIds = [], refreshing = false } = {}) {
  if (refreshing || !element?.isConnected || !(element.clientHeight > 0) || !targetIds.length) return false;
  const row = Array.from(element.querySelectorAll('[id^="msg-hl-"]'))
    .find(node => targetIds.some(id => node.id === `msg-hl-${id}`));
  if (!row || !(row.getBoundingClientRect().height > 0)) return false;
  // Images can finish without a message update. Failed loads count as complete.
  if (Array.from(element.querySelectorAll('img')).some(img => !img.complete)) return false;
  const maxOffset = Math.max(0, element.scrollHeight - element.clientHeight);
  return Math.abs(element.scrollTop - maxOffset) <= 2;
}

// Native list viewability only reports measured rows. An estimated end spacer
// is not enough: the latest real message must be visible at the acknowledged
// bottom, after the conversation's detail request has settled.
export function isNativeChatHistoryPositionReady(
  { targetIds = [], refreshing = false } = {},
  { visibleIds = [], offset = 0, layoutHeight = 0, contentHeight = 0 } = {},
) {
  if (refreshing || !targetIds.length || !(layoutHeight > 0) || !(contentHeight > 0)) return false;
  if (!targetIds.some(id => visibleIds.includes(id))) return false;
  const bottom = Math.max(0, contentHeight - layoutHeight);
  return Number.isFinite(offset) && Math.abs(offset - bottom) <= 2;
}
